import { render, staticRenderFns } from "./14_NpsQuestion.vue?vue&type=template&id=7f069f86&scoped=true&"
import script from "./14_NpsQuestion.vue?vue&type=script&lang=js&"
export * from "./14_NpsQuestion.vue?vue&type=script&lang=js&"
import style0 from "./14_NpsQuestion.vue?vue&type=style&index=0&id=7f069f86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f069f86",
  null
  
)

export default component.exports